import { Maybe } from 'maybeasy';
import { tailwindTheme } from '../../../Native/tailwind-theme';
import { ColorPalette, Theme } from '../../../Themes/ThemeContext/Types';

export const setIconColor = (color: Maybe<keyof ColorPalette>, theme: Theme) =>
  color.map((c) => theme.colors[c]).getOrElse(() => tailwindTheme.colors.white);
